<template>
    <div class="p-discount-rate-comparison__discount-select">
        <div class="u-margin-top-20 u-margin-bottom-10 u-bold">
            Discount Rates (please select a maximum of two)
        </div>
        <div class="flex-grid flex-grid--reduced-bottom-margin flex-grid--wrap u-r-flex-direction-row">
            <div class="a-checkbox a-checkbox--label-above" v-for="(discount, index) in discountRates">
                <input autocomplete="off" type="checkbox" :value="discount" @click="toggle" :disabled="disableRate(discount)" :checked="checkedRate(discount)">
                <label for="text">{{ discount+'%' }}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'discount-rates',
        computed: {
            ...mapState('discountRateComparison', [
                'discountRates',
                'chosenRates',
            ]),
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'toggleDiscountRate',
            ]),
            toggle(event) {
                this.toggleDiscountRate(event.target.value);
            },
            checkedRate(rate) {
                return !!this.chosenRates.find((chosen) => chosen === rate);
            },
            disableRate(rate) {
                if (this.checkedRate(rate)) {
                    return false;
                }

                // Maximum selection is 2 choices
                return this.chosenRates.length >= 2;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// DiscountRates.vue?6d25f300